import { SHARED_ENV } from './environment.shared';

export const environment = {
  ...SHARED_ENV,
  production: true,
  firebase: {
    apiKey: 'AIzaSyDAqSzIGFpWJEXyfnpDfDGYcIezAHHNTf4',
    authDomain: 'test-632f2.firebaseapp.com',
    databaseURL: 'https://test-632f2.firebaseio.com',
    projectId: 'test-632f2',
    storageBucket: 'test-632f2.appspot.com',
    messagingSenderId: '282633609802'
  },
  mainSystemUrl: 'https://sunip-test.legalsight.com',
  forecasterUrl: 'https://chiefip-test.legalsight.com',
  subscribeKey: 'sub-c-0e359214-c7d7-11e8-b017-9246cc6b239c',
  local: false,
  raygunKey: '8eS6ffrx62kQYwborG0SKQ==',
  msClarityProjectId: 'r459m0ztwr',
  msClarityEnabled: true,
};
